<template>
  <div v-if="releases.length" class="mb-5">
    <h1 class="fz-24">{{ $t('home.new') }}</h1>

    <swiper :slides-per-view="'auto'" :key="Math.random()">
      <swiper-slide v-for="(data, i) in releases" :key="`new-${i}`">
        <NewPodcast
          class="podcast-item"
          :new-podcast="data"
          @click="$router.push(`/course/${data.id}`)"
        />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import NewPodcast from '@/components/common/NewPodcast.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { useStore } from 'vuex';
import { computed } from 'vue';

import 'swiper/css';

export default {
  name: 'NewReleasesCarousel',

  components: {
    NewPodcast,
    Swiper,
    SwiperSlide,
  },
  props: {
    selectedCategory: {
      type: [String, Number],
      default: 'all',
    },
  },

  setup(props) {
    const store = useStore();
    const releases = computed(() => {
      const releases = store.getters['newReleases/getNewReleasesHome'];
      if (props.selectedCategory !== 'all') {
        return releases.filter(
          (course) => course.category_id === props.selectedCategory,
        );
      } else return releases;
    });

    return {
      releases,
    };
  },
};
</script>

<style scoped lang="scss">
.swiper-slide {
  width: auto;
}
</style>
